import { MultipleComplexValidator } from './multiple-complex.validator';
import { OrganizationLink } from '../../../../../swagger-api';

export class MultipleComplexItemsRequiredValidator implements MultipleComplexValidator {
  public errorKey = 'required';
  public items: Array<OrganizationLink> = [];

  get isValid(): boolean {
    return this.items.length > 0;
  }
}
